<template>
  <div class="container">
    <div class="tile">
      <div class="tile-content">
        <form class="form-horizontal" v-on:submit="save">
          <div class="form-group">
            <div class="container">
              <div class="columns">
                <div class="col-3 col-md-12">
                  <label class="form-label">{{question.text}}</label>
                </div>
                <div class="col-4 col-md-12">
                  <div class="input-group">
                    <textarea class="form-input" type="textarea" v-model="answer.atxt" @blur="save"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="tile-action">
      </div>
    </div>
  </div>
</template>

<script>
import baseQ from '@/components/questions/base'
export default {
  name: 'textareaQ',
  extends: baseQ
}
</script>



// WEBPACK FOOTER //
// textarea.vue?360ddeee